import { css } from 'styled-components'

const typography = css``

export const typographyPreset = css`
  .--truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export default typography
